import { INormalization } from '../types'
import { BOWTIE_BASE_URL, BOWTIE_REST_ENDPOINTS } from '../utils/constants'

export const getUniqueNormalization = async (): Promise<INormalization> => {
    return fetch(`${BOWTIE_BASE_URL}/${BOWTIE_REST_ENDPOINTS.normalization}/`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = null
        }

        if (data.ok) {
            return jsonData as INormalization
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}

export const getNormalizationByBarrierTypeId = async (barrierTypeId: number): Promise<INormalization> => {
    return fetch(`${BOWTIE_BASE_URL}/${BOWTIE_REST_ENDPOINTS.normalization}/barriertype/${barrierTypeId}`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = null
        }

        if (data.ok) {
            return jsonData as INormalization
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}

export const updateNormalization = async (normalization: INormalization): Promise<INormalization> => {
    return fetch(`${BOWTIE_BASE_URL}/${BOWTIE_REST_ENDPOINTS.normalization}/`, {
        method: 'PATCH',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(normalization)
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}
